export default {"src":"/_next/static/media/cake.0822c979.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};